(ns manage.content-variant-page.entities.tagging-tracker-ocp.view
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["src/svg/objects/tag.svg$default" :as Tag]
            [common.ui.tabs :refer [tabs]]
            [manage.content-variant-page.entities.tagging-tracker-ocp.db :as ocp.db]
            [manage.content-variant-page.entities.tagging.view :as tagging]
            [manage.content-variant-page.entities.tracker.view :as tracker]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [defui $]]
            [uix.re-frame :refer [use-subscribe]]))

(defui ocp-footer []
  (let [save-button-enabled (use-subscribe [::ocp.db/save-button-enabled])
        ongoing-save (use-subscribe [::ocp.db/ongoing-save])]
    ($ Stack {:direction "row"
              :justify-content "flex-end"
              :spacing 1
              :p 3}
       ($ Button
          {:variant "text"
           :disabled ongoing-save
           :on-click (fn [^js _event]
                       (rf/dispatch [:entity/close-view]))}
          "Cancel")
       ($ Button
          {:type "submit"
           :variant "contained"
           :disabled (or ongoing-save
                         (not save-button-enabled))
           :on-click (fn [^js _event]
                       (rf/dispatch [::ocp.db/save]))}
          "Save"))))

(defui tagging-and-trackers-panel []
  (let [is-adset-resource-loaded (= (:state (use-subscribe [:resource.adset/one])) :success)
        is-initialized (use-subscribe [::ocp.db/initialized])]
    (uix/use-effect (fn []
                      (when is-adset-resource-loaded
                        (rf/dispatch [::ocp.db/init])
                        (fn []
                          (rf/dispatch [::ocp.db/destroy]))))
                    [is-adset-resource-loaded])
    (when is-initialized
      ($ Stack {:direction "column"
                :sx #js {:height "100%"}}
         ($ tabs {:tabs {:tagging {:label "Tagging"
                                   :content ($ Box {:sx #js {:flex 1
                                                             :overflowY "auto"
                                                             :p 3}}
                                               ($ tagging/tab-panel))}
                         :tracker {:label "Trackers"
                                   :content ($ Box {:sx #js {:flex 1
                                                             :overflowY "auto"
                                                             :p 3}}
                                               ($ tracker/tab-panel))}}
                  :bind-active-tab-to-query-param true})
         ($ ocp-footer)))))

(defn entity-cfg [cc]
  {:entity/ref cc
   :entity/icon ($ Tag {:width 20
                        :height 20})
   :entity/label "Tagging & Trackers"
   ;; Makes the OCP larger when open.
   :entity.ocp/width "67%"
   :entity/content ($ tagging-and-trackers-panel)})
